import {getOccationalBanner} from "../../api/mainpage/occationalBanner";

const state = () => ({

  banner:{
    WebImgPath:'',
    mobileImgPath:'',
  },
  newsId: null
})


const getters = {
  get_banner(state) {
    return state.banner;
  },
}

const mutations = {
  SET_BANNER(state,data){
    state.banner = data;}
}

const actions = {
  async fetchBanner({ commit }) {
    try {
      const response = await getOccationalBanner();
      commit('SET_BANNER', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
